import i18n from '../plugins/i18n/i18n';
import moment from 'moment';


const ageRange = [
  {
    text: "18-20",
    value: 1,
  },
  {
    text: "21-25",
    value: 2,
  },
  {
    text: "26-30",
    value: 3,
  },
  {
    text: "31-35",
    value: 4,
  },
  {
    text: "36-40",
    value: 5,
  },
  {
    text: "41-45",
    value: 6,
  },
  {
    text: "46+",
    value: 7,
  },
];

const gender = [
  {
    text: i18n.t('man', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: i18n.t('Man', { lng: localStorage.getItem("i18nextLng").substr(0, 2) })

  }, {
    text: i18n.t('woman', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: i18n.t('Woman', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),

  },
  {
    text: i18n.t('none', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: i18n.t('None', { lng: localStorage.getItem("i18nextLng").substr(0, 2) })

  }
]

const status = [
  {
    label: i18n.t('active', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Active'
  },
  {
    label: i18n.t('inactive', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Inactive'
  }
]

const loginTypeTextValuePairs = [
  {
    text: i18n.t('standart', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'standart'
  },
  {
    text: i18n.t('singleSignOn', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'singleSignOn'
  }
]

const calculationTypeTextValuePairs = [
  {
    text: i18n.t('route', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'route'
  },
  {
    text: i18n.t('other', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'other'
  }
]

const paymentTypeTextValuePairs = [
  {
    text: i18n.t('CreditCard', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'CreditCard'
  },
  {
    text: i18n.t('BankTransfer', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'BankTransfer'
  }
]

const contractStatusTextValuePairs = [
  {
    text: i18n.t('Draft', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Draft'
  },
  {
    text: i18n.t('Active', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Active'
  },
  {
    text: i18n.t('Ended', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Ended'
  },
  {
    text: i18n.t('Removed', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Removed'
  }
]

const directionTypeTextValuePairs = [
  {
    text: i18n.t('departure', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'departure'
  },
  {
    text: i18n.t('return', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'return'
  }
]

const progressPaymentStatusTextValuePairs = [
  {
    text: i18n.t('approved', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'approved'
  },
  {
    text: i18n.t('waitingForCustomerApproval', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'waitingForCustomerApproval'
  },
  {
    text: i18n.t('rejectedByCustomer', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'rejectedByCustomer'
  },
  {
    text: i18n.t('failed', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'failed'
  }
]

const progressPaymentStatusWithoutTextValuePairs = [
  {
    text: i18n.t('approved', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'approved'
  },
  {
    text: i18n.t('waitingForCustomerApproval', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'waitingForCustomerApproval'
  },
  {
    text: i18n.t('failed', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'failed'
  }
]

const systemNotificationTypeTextValuePairs = [
  {
    text: i18n.t('general', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'general'
  },
  // {
  //   text: i18n.t('routePassenger', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
  //   value: 'route'
  // },
  {
    text: i18n.t('servicePassenger', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'service'
  },
  {
    text: i18n.t('serviceVehiclePassenger', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'serviceVehicle'
  }
]


const systemNotificationStatusTextValuePairs = [
  {
    text: i18n.t('sending', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Sending'
  },
  {
    text: i18n.t('sent', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Sent'
  }
]


const notificationChannelTextValuePairs = [
  {
    text: i18n.t('all', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'all'
  },
  {
    text: i18n.t('push', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'push'
  },
  {
    text: i18n.t('email', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'email'
  }
]

const serviceApprovalStatusTextValuePairs = [
  {
    text: i18n.t('waitingForApproval', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'waitingForApproval'
  },
  {
    text: i18n.t('approved', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'approved'
  },
  {
    text: i18n.t('rejected', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'rejected'
  }
]

const userServiceTypeTextValuePairs = [
  {
    text: i18n.t('subscription', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'subscription'
  },
  {
    text: i18n.t('onetime', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'onetime'
  }
]

const serviceStatusTextValuePairs = [
  {
    text: i18n.t('pending', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'pending'
  },
  {
    text: i18n.t('partial', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'partial'
  },
  {
    text: i18n.t('assigned', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'assigned'
  }
]

const routeTypeTextValuePairs = [
  {
    text: i18n.t('normal', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'normal'
  },
  {
    text: i18n.t('normalSingle', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'normalSingle'
  },
  {
    text: i18n.t('shiftOne', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'shiftOne'
  },
  {
    text: i18n.t('shiftOneSingle', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'shiftOneSingle'
  },
  {
    text: i18n.t('shiftTwo', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'shiftTwo'
  },
  {
    text: i18n.t('shiftTwoSingle', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'shiftTwoSingle'
  },
  {
    text: i18n.t('single', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'single'
  }
]

const contractStatusForEditTextValuePairs = [
  {
    text: i18n.t('Draft', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Draft'
  },
  {
    text: i18n.t('Active', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Active'
  }
]

const statusTextValuPairs = [
  {
    text: i18n.t('active', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Active'
  },
  {
    text: i18n.t('inactive', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Inactive'
  }
]

const serviceTypeTextValuePairs = [
  {
    text: i18n.t('serviceTypeFull', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'full'
  },
  {
    text: i18n.t('serviceTypePlatform', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'platform'
  }
]

const progressPaymentApproveTypeTextValuePairs = [
  {
    text: i18n.t('stopRate', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'stopRate'
  },
  {
    text: i18n.t('locationControl', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'locationControl'
  }
]

const progressPaymentPeriodTypeTextValuePairs = [
  {
    text: i18n.t('waitingForSendByVendor', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'waitingForSendByVendor'
  },
  {
    text: i18n.t('waitingForCustomerApproval', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'waitingForCustomerApproval'
  },
  {
    text: i18n.t('approvedByCustomer', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'approvedByCustomer'
  },
  {
    text: i18n.t('rejectedByCustomer', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'rejectedByCustomer'
  }
]

const durationStatusTextValuePairs = [
  {
    text: i18n.t('continues', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'false'
  },
  {
    text: i18n.t('expired', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'true'
  }
]

const sourceTextValuPairs = [
  {
    text: i18n.t('online', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Online'
  },
  {
    text: i18n.t('offline', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Offline'
  }
]

const priceTypeTextValuPairs = [
  {
    text: i18n.t('General', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'General'
  },
  {
    text: i18n.t('LocationBase', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'LocationBase'
  }
]

const productTypeTextValuPairs = [
  {
    text: i18n.t('FixedOffice', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'FixedOffice'
  },
  {
    text: i18n.t('FixedDesk', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'FixedDesk'
  },
  {
    text: i18n.t('VirtualOffice', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'VirtualOffice'
  },
  {
    text: i18n.t('Nomad', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Nomad'
  },
  {
    text: i18n.t('DigitalMembership', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'DigitalMembership'
  },
  {
    text: i18n.t('DailyPass', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'DailyPass'
  },
  {
    text: i18n.t('MeetingRoom', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'MeetingRoom'
  },
  {
    text: i18n.t('PrinterA4Grayscale', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'PrinterA4Grayscale'
  },
  {
    text: i18n.t('PrinterA4Colored', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'PrinterA4Colored'
  },
  {
    text: i18n.t('PrinterA3Grayscale', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'PrinterA3Grayscale'
  },
  {
    text: i18n.t('PrinterA3Colored', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'PrinterA3Colored'
  }
]

const feedbackFrequencyTextValuPairs = [
  {
    text: i18n.t('Weekly', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Weekly'
  },
  {
    text: i18n.t('Monthly', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Monthly'
  }
]

const yesNoTextValuPairs = [
  {
    text: i18n.t('true', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: true
  },
  {
    text: i18n.t('false', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: false
  }
]



const ticketStatus = [
  {
    label: i18n.t('Waiting', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Waiting'
  },
  {
    label: i18n.t('Solved', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Solved'
  },
  {
    label: i18n.t('UnSolvable', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'UnSolvable'
  }
]

const ticketStatusValuePairs = [
  {
    text: i18n.t('Waiting', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Waiting'
  },
  {
    text: i18n.t('Solved', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Solved'
  },
  {
    text: i18n.t('UnSolvable', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'UnSolvable'
  }
]

const ticketSourceValuePairs = [
  {
    text: "CoWork",
    label: "CoWork",
    value: 'CoWork'
  },
  {
    text: "Chatbot",
    label: "Chatbot",
    value: 'Chatbot'
  }
]



const ticketStatusUserOnly = [
  {
    label: i18n.t('Waiting', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Waiting'
  }
]

const feedbackScore = [
  {
    label: '1',
    value: 1
  },
  {
    label: '2',
    value: 2
  },
  {
    label: '3',
    value: 3
  },
  {
    label: '4',
    value: 4
  },
  {
    label: '5',
    value: 5
  },
]

const billStatus = [
  {
    label: i18n.t('Paid', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: i18n.t('Paid', { lng: localStorage.getItem("i18nextLng").substr(0, 2) })
  },
  {
    label: i18n.t('UnPaid', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: i18n.t('UnPaid', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
  }
]

const invoicePaymentStatus = [
  {
    text: i18n.t('Paid', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Paid'
  },
  {
    text: i18n.t('UnPaid', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'UnPaid'
  },
  {
    text: i18n.t('Partial', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Partial'
  }
]

const httpMethodTextValuPairs = [
  {
    text: i18n.t('GET', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'GET'
  },
  {
    text: i18n.t('POST', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'POST'
  },
  {
    text: i18n.t('PUT', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'PUT'
  },
  {
    text: i18n.t('PATCH', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'PATCH'
  },
  {
    text: i18n.t('DELETE', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'DELETE'
  }
]

const additionalPriceTypeTextValuPairs = [
  {
    text: i18n.t('bridge', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'KP'
  },
  {
    text: i18n.t('correction', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'DU'
  },
  {
    text: i18n.t('equipment', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'EK'
  },
  {
    text: i18n.t('highway', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'OT'
  },
  {
    text: i18n.t('material', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'MA'
  },
  {
    text: i18n.t('other', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'EU'
  }
]

const webhookEventTextValuPairs = [
  {
    text: i18n.t('companyCreate', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'companyCreate'
  },
  {
    text: i18n.t('companyUpdate', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'companyUpdate'
  },
  {
    text: i18n.t('companyGet', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'companyGet'
  },
  {
    text: i18n.t('companyGets', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'companyGets'
  },
  {
    text: i18n.t('invoiceCreate', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'invoiceCreate'
  },
  {
    text: i18n.t('invoiceGet', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'invoiceGet'
  },
  {
    text: i18n.t('invoicePaymentCreate', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'invoicePaymentCreate'
  },
  {
    text: i18n.t('invoicePaymentDelete', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'invoicePaymentDelete'
  }
]

const httpResponseStatusCodeTextValuPairs = [
  {
    text: i18n.t('200', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: '200'
  },
  {
    text: i18n.t('201', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: '201'
  },
  {
    text: i18n.t('400', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: '400'
  },
  {
    text: i18n.t('401', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: '401'
  },
  {
    text: i18n.t('404', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: '404'
  },
  {
    text: i18n.t('500', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: '500'
  }
]

const autoPaymentStatus = [
  {
    label: i18n.t('Paid', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: i18n.t('Paid', { lng: localStorage.getItem("i18nextLng").substr(0, 2) })
  },
  {
    label: i18n.t('UnPaid', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: i18n.t('UnPaid', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
  },
  {
    label: i18n.t('InsufficientBalance', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: i18n.t('InsufficientBalance', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
  },
  {
    label: i18n.t('AwaitingPayment', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: i18n.t('AwaitingPayment', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
  }
]

const roles = [
  {
    text: i18n.t('member', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 1
  },
  {
    text: i18n.t('memberAdmin', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 2
  },
  {
    text: i18n.t('systemAdmin', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 3
  }
]

const roleTextValuePairs = [
  {
    text: i18n.t('user', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: "User"
  },
  {
    text: i18n.t('SystemAdministrator', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: "SystemAdministrator"
  },
  {
    text: i18n.t('TechnicalAdministrator', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: "TechnicalAdministrator"
  },
  {
    text: i18n.t('CustomerAdmin', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: "CustomerAdmin"
  },
  // {
  //   text: i18n.t('CustomerLocationOfficer', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
  //   value: "CustomerLocationOfficer"
  // },
  {
    text: i18n.t('Vendor', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: "Vendor"
  },
  {
    text: i18n.t('Driver', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: "Driver"
  }
]

const messageTypeTextValuPairs = [
  {
    text: i18n.t('question', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: "Question"
  },
  {
    text: i18n.t('message', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: "Message"
  },
  {
    text: i18n.t('event', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: "Event"
  },
  {
    text: i18n.t('ticketResolved', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: "TicketResolved"
  },
  {
    text: i18n.t('invoiceUnPaid', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: "InvoiceUnPaid"
  }
]

const messageViewTypeTextValuPairs = [
  {
    text: i18n.t('message', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: "Message"
  },
  {
    text: i18n.t('Popup', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: "Popup"
  },
  {
    text: i18n.t('Bubble', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: "Bubble"
  }
]

const singleMessageViewTypeTextValuPairs = [
  {
    text: i18n.t('Popup', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: "Popup"
  },
  {
    text: i18n.t('Bubble', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: "Bubble"
  }
]

const getMinutes = () => {
  let minutesArray = [];
  for (let i = 0; i < 60; i++) {
    minutesArray.push({
      text: i + ' ' + i18n.t('shortMinute', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }).toUpperCase(),
      value: i
    })
  }
  return minutesArray;
}

const minutes = getMinutes();

const getMinutes5Steps = () => {
  let minutes5StepsArray = [];
  for (let i = 0; i < 61; i += 5) {
    minutes5StepsArray.push({
      text: i + ' ' + i18n.t('longMinute', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
      value:
        i < 10 ?
          `00:0${i}:00`
          :
          i === 60
            ?
            `01:00:00`
            :
            `00:${i}:00`
    })
  }
  return minutes5StepsArray;
}
const minutes5Steps = getMinutes5Steps();

const businessTypes = [
  {
    label: i18n.t('freelancer', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Freelancer'
  },
  {
    label: i18n.t('startup', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Startup'
  },
  {
    label: i18n.t('VC', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'VC'
  },
  {
    label: i18n.t('agency', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Agency'
  },
  {
    label: i18n.t('corporateBT', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Corporate'
  }
];



const businessTypeTextValuePairs = [
  {
    text: i18n.t('freelancer', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Freelancer'
  },
  {
    text: i18n.t('startup', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Startup'
  },
  {
    text: i18n.t('VC', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'VC'
  },
  {
    text: i18n.t('agency', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Agency'
  },
  {
    text: i18n.t('corporateBT', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Corporate'
  }
];

const companyTypes = [
  {
    label: i18n.t('corporate', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Corporate',
  },
  {
    label: i18n.t('personal', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Personal',
  }
]

const companyTypeTextValuPairs = [
  {
    text: i18n.t('corporate', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'corporate',
  },
  {
    text: i18n.t('personal', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'personal',
  }
]

const membershipTypes = [
  {
    label: i18n.t('virtualWithoutUsage', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'VirtualNoUsage',
  },
  {
    label: i18n.t('virtualWithUsage', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'VirtualYesUsage',
  },
  {
    label: i18n.t('privateOffice', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'PrivateOffice',
  },
  {
    label: i18n.t('fixedDesk', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'FixedDesk',
  },
  {
    label: i18n.t('nomad', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Nomad',
  },
  {
    label: i18n.t('meetingroommembership', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'MeetingRoomMembership',
  },
  {
    label: i18n.t('digitalMembership', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'DigitalMembership',
  },
]

const dailyRentTypeTextValuePairs = [
  {
    text: i18n.t('reservation', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Reservation',
  },
  {
    text: i18n.t('sales', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Sales',
  }
]

const promotionCodeTypeTextValuePairs = [
  {
    text: i18n.t('Normal', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Normal',
  },
  {
    text: i18n.t('FirstMonthIsFree', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'FirstMonthIsFree',
  },
  {
    text: i18n.t('FirstMonthIsFreeAfterAutoCancellation', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'FirstMonthIsFreeAfterAutoCancellation',
  }
]

const membershipTypeTextValuePairs = [
  {
    text: i18n.t('virtualWithoutUsage', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'VirtualNoUsage',
  },
  {
    text: i18n.t('virtualWithUsage', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'VirtualYesUsage',
  },
  {
    text: i18n.t('privateOffice', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'PrivateOffice',
  },
  {
    text: i18n.t('fixedDesk', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'FixedDesk',
  },
  {
    text: i18n.t('nomad', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Nomad',
  },
  {
    text: i18n.t('meetingroommembership', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'MeetingRoomMembership',
  },
  {
    text: i18n.t('digitalMembership', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'DigitalMembership',
  },
]

const promotionCodeMembershipTypes = [
  {
    label: i18n.t('virtualWithoutUsage', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'VirtualNoUsage',
  },
  {
    label: i18n.t('virtualWithUsage', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'VirtualYesUsage',
  },
  {
    label: i18n.t('nomad', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Nomad',
  },
  {
    label: i18n.t('digitalMembership', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'DigitalMembership',
  },
]

const promotionCodeMembershipTypeTextValuePairs = [
  {
    text: i18n.t('virtualWithoutUsage', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'VirtualNoUsage',
  },
  {
    text: i18n.t('virtualWithUsage', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'VirtualYesUsage',
  },
  {
    text: i18n.t('nomad', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Nomad',
  },
  {
    text: i18n.t('digitalMembership', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'DigitalMembership',
  },
]

const ticketTypes = [
  {
    label: i18n.t('requestOrSuggestion', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'RequestOrSuggestion',
  },
  {
    label: i18n.t('complaint', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Complaint',
  }
]

const userSegmentFilterTypes = [
  {
    label: i18n.t('allMemberships', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'AllMemberships',
  },
  {
    label: i18n.t('customFilter', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'CustomFilter',
  },
  // {
  //   label: i18n.t('ticketResolved', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
  //   value: 'TicketResolved',
  // },
  // {
  //   label: i18n.t('invoiceUnPaid', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
  //   value: 'InvoiceUnPaid',
  // },
  {
    label: i18n.t('csvImport', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'CsvImport',
  }
]

const minimumReservationDurations = [
  {
    label: 30 + ' ' + i18n.t('longMinute', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: '00:30:00'
  },
  {
    label: 1 + ' ' + i18n.t('longHour', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: '01:00:00'
  },
  {
    label: 2 + ' ' + i18n.t('longHour', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: '02:00:00',
  },
  {
    label: 3 + ' ' + i18n.t('longHour', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: '03:00:00',
  }
]

const maximumReservationDurations = [
  {
    label: 4 + ' ' + i18n.t('longHour', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: '04:00:00',
  },
  {
    label: 5 + ' ' + i18n.t('longHour', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: '05:00:00',
  },
  {
    label: 6 + ' ' + i18n.t('longHour', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: '06:00:00',
  }
]

const cancellationDurations = [
  {
    label: 30 + ' ' + i18n.t('longMinute', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: '00:30:00',
  },
  {
    label: 1 + ' ' + i18n.t('longHour', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: '01:00:00',
  }
]

const locationTypes = [
  {
    label: i18n.t('internalLocation', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'Internal'
  },
  {
    label: i18n.t('externalLocation', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 'External',
  }
]

const invoiceFrequencyTextValuPairs = [
  {
    text: i18n.t('everyMonth', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: 1
  },
  // {
  //   text: i18n.t('onceIn3Months', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
  //   value: 3
  // },
  // {
  //   text: i18n.t('onceIn6Months', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
  //   value: 6
  // },
  // {
  //   text: i18n.t('yearly', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
  //   value: 12
  // }
]

const productRenewalTypeTextValuPairs = [
  {
    text: i18n.t('now', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: "Now"
  },
  {
    text: i18n.t('onTheRenewalDate', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: "OnTheRenewalDate"
  },

]

const currencyTypes = [
  {
    label: 'Try',
    value: 'Try'
  },
  {
    label: 'Usd',
    value: 'Usd',
  }
]

const eventDates = [
  {
    label: i18n.t('today', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: `(dateTime~gt~datetime'${moment().format('YYYY-MM-DD')}T00-00-00')~and~(dateTime~lt~datetime'${moment().format('YYYY-MM-DD')}T23-59-59')`,
  },
  {
    label: i18n.t('tomorrow', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: `(dateTime~gt~datetime'${moment().add(1, "days").format('YYYY-MM-DD')}T00-00-00')~and~(dateTime~lt~datetime'${moment().add(1, "days").format('YYYY-MM-DD')}T23-59-59')`,
  },
  {
    label: i18n.t('thisWeek', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: `(dateTime~gt~datetime'${moment().weekday(0 + 1).format('YYYY-MM-DD')}T00-00-00')~and~(dateTime~lt~datetime'${moment().weekday(0 + 7).format('YYYY-MM-DD')}T23-59-59')`,
  },
  {
    label: i18n.t('thisMonth', { lng: localStorage.getItem("i18nextLng").substr(0, 2) }),
    value: `(dateTime~gt~datetime'${moment().startOf('month').format('YYYY-MM-DD')}T00-00-00')~and~(dateTime~lt~datetime'${moment().endOf('month').format('YYYY-MM-DD')}T23-59-59')`,
  },
];

const generateMonthTextValuePairs = () => {

  let months = []
  for (let i = 0; i < 12; i++) {

    let newItem = {
      value: i + 1,
      text: `${i + 1} ${i18n.t(`month`, {
        lng: localStorage.getItem("i18nextLng").substr(0, 2),
      })}`
    }
    months.push(newItem)
  }

  return months;
}

const monthTextValuePairs = generateMonthTextValuePairs();


const googleMapsStyle = [
  {
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#f5f5f5'
      }
    ]
  },
  {
    'elementType': 'labels.icon',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  },
  {
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#616161'
      }
    ]
  },
  {
    'elementType': 'labels.text.stroke',
    'stylers': [
      {
        'color': '#f5f5f5'
      }
    ]
  },
  {
    'featureType': 'administrative.land_parcel',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#bdbdbd'
      }
    ]
  },
  {
    'featureType': 'poi',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#eeeeee'
      }
    ]
  },
  {
    'featureType': 'poi',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#757575'
      }
    ]
  },
  {
    'featureType': 'poi.park',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#e5e5e5'
      }
    ]
  },
  {
    'featureType': 'poi.park',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#9e9e9e'
      }
    ]
  },
  {
    'featureType': 'road',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#ffffff'
      }
    ]
  },
  {
    'featureType': 'road.arterial',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#757575'
      }
    ]
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#dadada'
      }
    ]
  },
  {
    'featureType': 'road.highway',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#616161'
      }
    ]
  },
  {
    'featureType': 'road.local',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#9e9e9e'
      }
    ]
  },
  {
    'featureType': 'transit.line',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#e5e5e5'
      }
    ]
  },
  {
    'featureType': 'transit.station',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#eeeeee'
      }
    ]
  },
  {
    'featureType': 'water',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#c9c9c9'
      }
    ]
  },
  {
    'featureType': 'water',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#9e9e9e'
      }
    ]
  }
];


export {
  ageRange,
  gender,
  status,
  roles,
  minutes,
  businessTypes,
  companyTypes,
  membershipTypes,
  ticketStatus,
  ticketStatusUserOnly,
  billStatus,
  autoPaymentStatus,
  minimumReservationDurations,
  maximumReservationDurations,
  cancellationDurations,
  minutes5Steps,
  locationTypes,
  currencyTypes,
  eventDates,
  feedbackScore,
  ticketTypes,
  userSegmentFilterTypes,
  companyTypeTextValuPairs,
  membershipTypeTextValuePairs,
  businessTypeTextValuePairs,
  messageTypeTextValuPairs,
  messageViewTypeTextValuPairs,
  singleMessageViewTypeTextValuPairs,
  statusTextValuPairs,
  yesNoTextValuPairs,
  ticketStatusValuePairs,
  promotionCodeMembershipTypeTextValuePairs,
  promotionCodeMembershipTypes,
  dailyRentTypeTextValuePairs,
  promotionCodeTypeTextValuePairs,
  feedbackFrequencyTextValuPairs,
  ticketSourceValuePairs,
  productTypeTextValuPairs,
  priceTypeTextValuPairs,
  paymentTypeTextValuePairs,
  contractStatusTextValuePairs,
  monthTextValuePairs,
  invoiceFrequencyTextValuPairs,
  sourceTextValuPairs,
  productRenewalTypeTextValuPairs,
  invoicePaymentStatus,
  contractStatusForEditTextValuePairs,
  httpMethodTextValuPairs,
  httpResponseStatusCodeTextValuPairs,
  webhookEventTextValuPairs,
  loginTypeTextValuePairs,
  calculationTypeTextValuePairs,
  roleTextValuePairs,
  routeTypeTextValuePairs,
  directionTypeTextValuePairs,
  serviceStatusTextValuePairs,
  serviceApprovalStatusTextValuePairs,
  durationStatusTextValuePairs,
  progressPaymentStatusTextValuePairs,
  serviceTypeTextValuePairs,
  userServiceTypeTextValuePairs,
  systemNotificationTypeTextValuePairs,
  systemNotificationStatusTextValuePairs,
  notificationChannelTextValuePairs,
  progressPaymentPeriodTypeTextValuePairs,
  additionalPriceTypeTextValuPairs,
  progressPaymentApproveTypeTextValuePairs,
  progressPaymentStatusWithoutTextValuePairs,
  googleMapsStyle
}





// WEBPACK FOOTER //
// ./src/helpers/constants.js